import type {FC, ReactNode} from 'react'
import tw from 'twin.macro'
import styled from 'styled-components'
import {BsExclamationCircleFill} from 'react-icons/bs'

const PopoverContainer = styled.div<{
  top?: number
  left?: number
  right?: number
  central?: boolean
  maxWidth?: number
}>`
  z-index: 100000;
  position: fixed;
  top: ${({top}) => `${top || 0}px`};
  left: ${({left}) => left && `${left || 0}px`};
  right: ${({right}) => right && `${right || 0}px`};
  ${({central}) => central && tw`flex flex-row justify-center w-full`}
  ${({maxWidth, central}) => {
    if (maxWidth) {
      return `max-width: ${maxWidth}px;`
    }
    if (!central) {
      return 'max-width: min(35vw, 500px);'
    }
    return ''
  }}
`

const PopoverMain = styled.div`
  ${tw`flex`}
  box-shadow: 0px 0px 10px rgba(54, 250, 215, 0.5);
  border-radius: 10px;
`

const PopoverBody = styled.div<{hasSuffix?: boolean}>`
  ${tw`px-6 py-3.5 flex flex-row items-center`}
  ${tw`text-sm text-white font-primary font-light`}
  background: #111;
  border-radius: 10px;
  ${({hasSuffix}) =>
    hasSuffix && 'border-top-right-radius: 0; border-bottom-right-radius: 0;'}

  p {
    ${tw`leading-6`}
  }
`

const IconContainer = tw.div`h-5 w-5 mr-6`

const StyledAsideIcon = styled(BsExclamationCircleFill)`
  ${tw`text-brand text-xl`}
`

const Button = styled.button`
  ${tw`px-10 text-black text-lg font-medium font-primary bg-brand relative`}
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
`

const ButtonInner = tw.div`
  absolute left-0 top-0 bottom-0 right-0 overflow-auto flex flex-row justify-center items-center
`

const BannerText = tw.span``

export const TourPopover: FC<{
  children: ReactNode
  top?: number
  left?: number
  right?: number
  maxWidth?: number
  central?: boolean
  actionText?: string
  action?: () => void
}> = ({children, top, left, right, maxWidth, central, actionText, action}) => {
  const hasSuffix = !!action
  return (
    <PopoverContainer
      top={top}
      left={left}
      right={right}
      central={central}
      maxWidth={maxWidth}
    >
      <PopoverMain>
        <PopoverBody hasSuffix={hasSuffix}>
          <IconContainer>
            <StyledAsideIcon />
          </IconContainer>
          <div>{children}</div>
        </PopoverBody>
        {hasSuffix && (
          <Button onClick={action}>
            <ButtonInner>
              <BannerText>{actionText || 'OK'}</BannerText>
            </ButtonInner>
          </Button>
        )}
      </PopoverMain>
    </PopoverContainer>
  )
}
